import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

import { list_user } from 'src/app/core/constants/lead-const';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { CheckTaskStatusService } from 'src/app/core/services/check-task-status-service/check-task-status-service';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { FeatureToggleService } from 'src/app/core/toggle/feature-toggle.service';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';
import { LeadCampaignService } from '../lead-campaign.service';

@Component({
  selector: 'app-model-summary',
  templateUrl: './model-summary.component.html',
  styleUrls: ['./model-summary.component.scss']
})
export class ModelSummaryComponent implements OnInit {

  @Output() public closeSummary = new EventEmitter<boolean>();
  @Output() public backLevel = new EventEmitter<boolean>();
  @Output() public finished = new EventEmitter<boolean>();

  @Input() public isSummary = false;
  @Input() public formSummary: FormGroup;

  public listUSers = list_user;
  public isChecked = false;
  public isLoading = false;
  public isSegmentationAvailable: boolean;

  constructor(
    private scroll: WindowScrollService,
    private lcs: LeadCampaignService,
    private snackService: SnackbarService,
    private envSvc: EnvironmentService,
    private featureToggleService: FeatureToggleService
  ) { }

  ngOnInit(): void {
    this.checkToggles();
  }

  private checkToggles() {
    this.isSegmentationAvailable = this.featureToggleService.isActive('toggle_lopes_lead_segmentation_available');
  }

  get participants() {
    return this.formSummary.get('participants') as FormArray;
  }

  public closeModal(): void {
    this.backLevel.emit(false);
    this.scroll.disable();
  }

  public save(): void {
    this.isLoading = true;
    this.lcs.setCampaignParticipants(this.formSummary.get('id').value, this.createParticipantsForm())
    .subscribe(resp => {
        this.isLoading = false;
        this.isSummary = false;
        this.closeSummary.emit(false);
        this.finished.emit(true)
      },
      err => {
        if (err && err.error.messages) {
          this.snackService.show(err.error.messages[0]?.message, 'error', 10);
        } else {
          this.snackService.show('Não foi possível inscrever os participantes.', 'error', 10);
        }
        this.isLoading = false;
        this.isSummary = true;
      });
  }

  createParticipantsForm() {
    const participantsForm = {
      participants: this.participants.getRawValue(),
      investment_amount: this.returnValueAsNumber(this.formSummary.get('value_invest').value),
      segmentation_type: this.formSummary.get('type_segmentation').value?.value
    };
    participantsForm.participants.forEach(part => {
      part.participation_percentage = Number(part.participation_percentage);
    });
    return participantsForm;
  }

  returnValueAsNumber(value: string): number {
    let num;
    num = value.replace('.', '');
    num = num.replace(',', '.');
    return parseFloat(num);
  }

  public getParticipants() {
    const total = this.lcs.parseCurrency(this.formSummary.getRawValue().value_invest);
    let participants = this.formSummary.getRawValue().participants.map(part => {
      part.participation_value = this.getValue(
        total,
        part.participation_percentage
      );
      return part;
    });

    return participants
  }

  public getValue(amount, percent): number {
    return Number((amount / 100 * percent).toFixed(2));
  }
}